import React, { Suspense, lazy } from 'react';
import AttendanceKiosk from './pages/AttendanceKiosk';
import KioskSecurityEntry from './KioskSecurityEntry';

// Keep the ERP and its modern financial arithmetic outside the kiosk startup graph.
const MainApp = lazy(() => import('./App'));
export const isKioskPath = pathname => /^\/kiosk\/?$/i.test(pathname || '');

export const isKioskSetupPath = pathname => /^\/kiosk-setup\/?$/i.test(pathname || '');

class StartupBoundary extends React.Component {
  constructor(props) { super(props); this.state = { failed: false, message: '' }; }
  static getDerivedStateFromError(error) { return { failed: true, message: String(error && error.message || 'Unknown startup error').slice(0,300) }; }
  render() {
    if (this.state.failed) {
      return <main role="alert" style={{padding:24,fontFamily:'sans-serif'}}>
        <h1>BloansBooks could not open</h1>
        <p>Reload the page. If this continues, show this message to your administrator.</p>
        <p>Startup detail: {this.state.message}</p>
        <p><a href="/kiosk-setup">Open the office iPad setup page</a></p>
        <button type="button" onClick={() => window.location.reload()}>Reload page</button>
      </main>;
    }
    return this.props.children;
  }
}
export default function KioskEntry({pathname = window.location.pathname}) {
  return <StartupBoundary>
    {isKioskSetupPath(pathname) ? <KioskSecurityEntry /> : isKioskPath(pathname) ? <AttendanceKiosk /> :
      <Suspense fallback={<p role="status" style={{padding:24}}>Loading BloansBooks…</p>}><MainApp /></Suspense>}
  </StartupBoundary>;
}
